import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "onClick"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "w-4" }
const _hoisted_4 = { class: "text-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.0636 11.1392H11.4782",
    stroke: "#515151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.47478 1.00552C6.94691 0.441251 7.79563 0.35851 8.3716 0.821044C8.40345 0.846138 9.42663 1.64099 9.42663 1.64099C10.0594 2.0235 10.256 2.83666 9.86484 3.45722C9.84407 3.49045 4.05943 10.7262 4.05943 10.7262C3.86698 10.9663 3.57484 11.108 3.26263 11.1114L1.04735 11.1392L0.548225 9.02662C0.478306 8.72956 0.548225 8.41759 0.740677 8.17751L6.47478 1.00552Z",
    stroke: "#515151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.40393 2.34833L8.72269 4.89701",
    stroke: "#515151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_6 = { class: "px-1 py-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-edit",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 5l3 3" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "pl-2 fs-16" }, "Edit", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-trash",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "4",
    y1: "7",
    x2: "20",
    y2: "7"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "10",
    y1: "11",
    x2: "10",
    y2: "17"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "14",
    y1: "11",
    x2: "14",
    y2: "17"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "pl-2 fs-16" }, "Delete", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "flex gap-4 items-center" }
const _hoisted_17 = { class: "w-14" }
const _hoisted_18 = ["src", "onClick"]
const _hoisted_19 = { class: "w-32" }
const _hoisted_20 = { class: "text-title" }
const _hoisted_21 = { class: "flex gap-4 justify-between items-center w-full" }
const _hoisted_22 = { class: "flex justify-end w-20" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = ["id", "checked", "onChange"]
const _hoisted_25 = ["for"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.0636 11.1392H11.4782",
    stroke: "#515151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.47478 1.00552C6.94691 0.441251 7.79563 0.35851 8.3716 0.821044C8.40345 0.846138 9.42663 1.64099 9.42663 1.64099C10.0594 2.0235 10.256 2.83666 9.86484 3.45722C9.84407 3.49045 4.05943 10.7262 4.05943 10.7262C3.86698 10.9663 3.57484 11.108 3.26263 11.1114L1.04735 11.1392L0.548225 9.02662C0.478306 8.72956 0.548225 8.41759 0.740677 8.17751L6.47478 1.00552Z",
    stroke: "#515151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.40393 2.34833L8.72269 4.89701",
    stroke: "#515151",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_27 = { class: "px-1 py-1" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-edit",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 5l3 3" })
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "pl-2 fs-16" }, "Edit", -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-trash",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "4",
    y1: "7",
    x2: "20",
    y2: "7"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "10",
    y1: "11",
    x2: "10",
    y2: "17"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "14",
    y1: "11",
    x2: "14",
    y2: "17"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" })
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "pl-2 fs-16" }, "Delete", -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_LoadingArrow = _resolveComponent("LoadingArrow")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_editModal = _resolveComponent("editModal")!
  const _component_deleteModal = _resolveComponent("deleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Draggable, {
      list: _ctx.lists,
      "item-key": "_id",
      move: _ctx.checkMove,
      onStart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dragging = true)),
      onEnd: _ctx.endDragging
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "box justify-between min-w-max mb-2",
            ref: `header-${element.Id}`,
            id: `header-${element.Id}`,
            onClick: ($event: any) => (_ctx.loadData(element as any, element.Id))
          }, [
            _createElementVNode("div", {
              class: "flex gap-2 items-center cursor-pointer",
              id: `icon-${element.Id}`
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ArrowRight),
                _createVNode(_component_LoadingArrow, { class: "icon-hidden" }),
                _createVNode(_component_ArrowDown, { class: "icon-hidden" })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(element.Name), 1)
              ])
            ], 8, _hoisted_2),
            _createVNode(_component_Menu, {
              as: "div",
              class: "relative inline-block text-left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_MenuButton, { class: "button-nav" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_Transition, {
                  "enter-active-class": "transition duration-100 ease-out",
                  "enter-from-class": "transform scale-95 opacity-0",
                  "enter-to-class": "transform scale-100 opacity-100",
                  "leave-active-class": "transition duration-75 ease-in",
                  "leave-from-class": "transform scale-100 opacity-100",
                  "leave-to-class": "transform scale-95 opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MenuItems, { class: "absolute z-50 right-0 mt-2 w-36 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_MenuItem, null, {
                            default: _withCtx(({ active }) => [
                              _createElementVNode("button", {
                                class: _normalizeClass([
                                        active ? 'bg-violet-500 text-gray-400' : 'text-gray-900',
                                        'group flex w-full items-center rounded-md px-2 py-2 text-sm',
                                    ]),
                                onClick: ($event: any) => (_ctx.toggleEditModal(element, 'category'))
                              }, _hoisted_10, 10, _hoisted_7)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_MenuItem, null, {
                            default: _withCtx(({ active }) => [
                              _createElementVNode("button", {
                                class: _normalizeClass([
                                        active ? 'bg-violet-500 text-gray-400' : 'text-gray-900',
                                        'group flex w-full items-center rounded-md px-2 py-2 text-sm',
                                    ]),
                                onClick: ($event: any) => (_ctx.toggleDeleteModal(element, 'category'))
                              }, _hoisted_14, 10, _hoisted_11)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.Children, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "box justify-between min-w-max",
              key: item,
              ref_for: true,
              ref: `body-${item.Id}`,
              id: `body-${item.Id}`
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    src: item.Qr,
                    onClick: ($event: any) => (_ctx.helpers.openQr(item.Qr)),
                    class: "cursor-pointer"
                  }, null, 8, _hoisted_18)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(item.Name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: `table-${item.Id}`,
                      class: "hidden",
                      checked: !item.IsActive,
                      onChange: ($event: any) => (_ctx.updateIsActive(item.Id, !item.IsActive))
                    }, null, 40, _hoisted_24),
                    _createElementVNode("label", {
                      for: `table-${item.Id}`,
                      id: "toggle",
                      class: "bg-[#D1E8B4] cursor-pointer h-5 relative rounded-full w-9"
                    }, null, 8, _hoisted_25)
                  ])
                ]),
                _createVNode(_component_Menu, {
                  as: "div",
                  class: "relative inline-block text-left"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_MenuButton, { class: "button-nav" }, {
                        default: _withCtx(() => [
                          _hoisted_26
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_Transition, {
                      "enter-active-class": "transition duration-100 ease-out",
                      "enter-from-class": "transform scale-95 opacity-0",
                      "enter-to-class": "transform scale-100 opacity-100",
                      "leave-active-class": "transition duration-75 ease-in",
                      "leave-from-class": "transform scale-100 opacity-100",
                      "leave-to-class": "transform scale-95 opacity-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MenuItems, { class: "absolute z-50 right-0 mt-2 w-36 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_MenuItem, null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("button", {
                                    class: _normalizeClass([
                                            active ? 'bg-violet-500 text-gray-400' : 'text-gray-900',
                                            'group flex w-full items-center rounded-md px-2 py-2 text-sm',
                                        ]),
                                    onClick: ($event: any) => (_ctx.toggleEditModal(item, 'table'))
                                  }, _hoisted_31, 10, _hoisted_28)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_MenuItem, null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("button", {
                                    class: _normalizeClass([
                                            active ? 'bg-violet-500 text-gray-400' : 'text-gray-900',
                                            'group flex w-full items-center rounded-md px-2 py-2 text-sm',
                                        ]),
                                    onClick: ($event: any) => (_ctx.toggleDeleteModal(item, 'table'))
                                  }, _hoisted_35, 10, _hoisted_32)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ])
            ], 8, _hoisted_15))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["list", "move", "onEnd"]),
    (_ctx.editCategory)
      ? (_openBlock(), _createBlock(_component_editModal, {
          key: 0,
          item: _ctx.editData,
          onClose: _ctx.toggleEditModal
        }, null, 8, ["item", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.deleteCategory)
      ? (_openBlock(), _createBlock(_component_deleteModal, {
          key: 1,
          item: _ctx.deleteData,
          onClose: _ctx.toggleDeleteModal
        }, null, 8, ["item", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}